__turbopack_context__.v({
  "close-btn": "TurnrInput-module-scss-module__JMZcia__close-btn",
  "container": "TurnrInput-module-scss-module__JMZcia__container",
  "disabled": "TurnrInput-module-scss-module__JMZcia__disabled",
  "error": "TurnrInput-module-scss-module__JMZcia__error",
  "fieldset": "TurnrInput-module-scss-module__JMZcia__fieldset",
  "floating-label": "TurnrInput-module-scss-module__JMZcia__floating-label",
  "helper-text": "TurnrInput-module-scss-module__JMZcia__helper-text",
  "helper-text-error": "TurnrInput-module-scss-module__JMZcia__helper-text-error",
  "input": "TurnrInput-module-scss-module__JMZcia__input",
  "input-has-value": "TurnrInput-module-scss-module__JMZcia__input-has-value",
  "input-left-icon": "TurnrInput-module-scss-module__JMZcia__input-left-icon",
  "input-right-icon": "TurnrInput-module-scss-module__JMZcia__input-right-icon",
  "input-right-icon-2": "TurnrInput-module-scss-module__JMZcia__input-right-icon-2",
  "input-right-icon-3": "TurnrInput-module-scss-module__JMZcia__input-right-icon-3",
  "input-type-color": "TurnrInput-module-scss-module__JMZcia__input-type-color",
  "label-locked": "TurnrInput-module-scss-module__JMZcia__label-locked",
  "left-icon": "TurnrInput-module-scss-module__JMZcia__left-icon",
  "legend": "TurnrInput-module-scss-module__JMZcia__legend",
  "no-title": "TurnrInput-module-scss-module__JMZcia__no-title",
  "open": "TurnrInput-module-scss-module__JMZcia__open",
  "read-only": "TurnrInput-module-scss-module__JMZcia__read-only",
  "right-icon": "TurnrInput-module-scss-module__JMZcia__right-icon",
  "right-icon-clickable": "TurnrInput-module-scss-module__JMZcia__right-icon-clickable",
  "right-icon-with-tooltip": "TurnrInput-module-scss-module__JMZcia__right-icon-with-tooltip",
  "size-small": "TurnrInput-module-scss-module__JMZcia__size-small",
  "tooltip-wrapper": "TurnrInput-module-scss-module__JMZcia__tooltip-wrapper",
  "value-changed": "TurnrInput-module-scss-module__JMZcia__value-changed",
  "value-changed-box": "TurnrInput-module-scss-module__JMZcia__value-changed-box",
});
